import React, { useState, useEffect } from 'react'; 
import {
  Typography,
  Tabs,
  Tab,
  Box,
  Container,
  TextField,
  Button,
  Paper,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import Footer from '../Materials/Footer';
import BurgerBar from '../Materials/BurgerBar';



export default function CreateDataPage() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [showInvestigationGroup, setShowInvestigationGroup] = useState(false);
  const [showSubEntity, setShowSubEntity] = useState(false);
  const location = useLocation();
  // States para Equipments
  const [entityId, setEntityId] = useState(location.state?.entityId || '');
  const [subEntityId, setSubEntityId] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [categories, setCategories] = useState([]);
  const [matriceId, setMatriceId] = useState('');
  const [matrices, setMatrices] = useState([]);
  const [processType, setProcessType] = useState('');
  const [processTypes, setProcessTypes] = useState([]);
  const [equipmentName, setEquipmentName] = useState('');
  const [applications, setApplications] = useState('');
  const [observations, setObservations] = useState('');
  const [scales, setScales] = useState('');
  const [mainSpecs, setMainSpecs] = useState('');

  // States para Patents
  const [patentEntityId, setPatentEntityId] = useState(location.state?.entityId || '');
  const [publicationNumber, setPublicationNumber] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [title, setTitle] = useState('');
  const [inventor, setInventor] = useState('');

  // States para Projects
  const [projectEntityId, setProjectEntityId] = useState(location.state?.entityId || '');
  const [projectName, setProjectName] = useState('');
  const [link, setLink] = useState('');
  const [onGoing, setOnGoing] = useState(false);
  const [projectAcronym, setProjectAcronym] = useState('');

  // States para Skills (R&I)
  const [skillEntityId, setSkillEntityId] = useState(location.state?.entityId || '');
  const [researchAreasFieldId, setResearchAreasFieldId] = useState('');
  const [researchAreasFields, setResearchAreasFields] = useState([]);
  const [mainKeywords, setMainKeywords] = useState('');
  const [researchTopics, setResearchTopics] = useState('');
  const [specificKeywords, setSpecificKeywords] = useState('');


  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // States para Research Area Field
  const [researchAreaDescription, setResearchAreaDescription] = useState('');
  const [openResearchAreaModal, setOpenResearchAreaModal] = useState(false);

  // States para Matrices
  const [matrixEntityId, setMatrixEntityId] = useState(location.state?.entityId || '');
  const [matrixObservations, setMatrixObservations] = useState('');
  const [matriceCategories, setMatriceCategories] = useState([]);

  // States para Matrice Category
  const [matriceCategoryMatriceId, setMatriceCategoryMatriceId] = useState('');
  const [matriceCategoryDescription, setMatriceCategoryDescription] = useState('');

  // States para Matrice Subcategory
  const [matriceSubcategoryCategoryId, setMatriceSubcategoryCategoryId] = useState('');
  const [matriceSubcategoryDescription, setMatriceSubcategoryDescription] = useState('');

  //Checkboxes da Faculty
  const [isInvestigationGroup, setIsInvestigationGroup] = useState(false);
  const [isSubEntity, setIsSubEntity] = useState(false);

  // Função para lidar com a checkbox "Is Investigation Group?"
  const handleInvestigationGroupChange = (event) => {
    setIsInvestigationGroup(event.target.checked);
  };

  const [subEntityName, setSubEntityName] = useState('');
  const [createdSubEntityId, setCreatedSubEntityId] = useState('');

  // Função para lidar com a checkbox "Is Sub-Entity?"
  const handleSubEntityChange = (event) => {
    setIsSubEntity(event.target.checked);
  };
  // Estados para Investigation Group
  const [entityIdIG, setEntityIdIG] = useState(location.state?.entityId || '');
  const [subEntityIdIG, setSubEntityIdIG] = useState('');
  const [researchLine, setResearchLine] = useState('');
  const [researcherName, setResearcherName] = useState('');
  const [researcherCv, setResearcherCv] = useState('');
  const [email, setEmail] = useState('');
  const [biography, setBiography] = useState('');
  const [descriptionIG, setDescriptionIG] = useState('');

  // Estados para Sub Entity
  const [entityIdSE, setEntityIdSE] = useState(location.state?.entityId || '');
  const [type, setType] = useState('');
  const [nameSE, setNameSE] = useState('');
  const [contact, setContact] = useState('');
  const [location1, setLocation] = useState('');

  // Função para criar Matriz
  const handleCreateMatrix = async () => {
    const newMatrix = {
      entity_id: matrixEntityId === '' ? null : matrixEntityId,
      observations: matrixObservations
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newMatrix)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a matriz');
      }

      alert('Matriz criada com sucesso!');
    } catch (error) {
      alert('Erro ao criar matriz');
    }
  };

  // ✅ Função para buscar as categorias da API
  const fetchCategories = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/categories');
      if (!response.ok) {
        throw new Error('Erro ao buscar categorias');
      }
      const data = await response.json();
      setCategories(data); // Guardar as categorias no estado
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
    }
  };

  // ✅ Buscar categorias quando o componente monta
  useEffect(() => {
    fetchCategories();
  }, []);

  // ✅ Função para buscar as matrizes da API
  const fetchMatrices = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrices');
      if (!response.ok) {
        throw new Error('Erro ao buscar matrizes');
      }
      const data = await response.json();
      setMatrices(data); // Guardar as matrizes no estado
    } catch (error) {
      console.error('Erro ao buscar matrizes:', error);
    }
  };

  // ✅ Buscar matrizes quando o componente monta
  useEffect(() => {
    fetchMatrices();
  }, []);

  // ✅ Função para buscar os process types da API
  const fetchProcessTypes = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/process-types');
      if (!response.ok) {
        throw new Error('Erro ao buscar process types');
      }
      const data = await response.json();
      setProcessTypes(data); // Guardar os process types no estado
    } catch (error) {
      console.error('Erro ao buscar process types:', error);
    }
  };

  // ✅ Buscar process types quando o componente monta
  useEffect(() => {
    fetchProcessTypes();
  }, []);

  // ✅ Função para buscar as Matrice Categories da API
  const fetchMatriceCategories = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrice-categories');
      if (!response.ok) {
        throw new Error('Erro ao buscar as categorias de matriz');
      }
      const data = await response.json();
      setMatriceCategories(data); // Guardar as categorias no estado
    } catch (error) {
      console.error('Erro ao buscar as categorias de matriz:', error);
    }
  };

  // ✅ Buscar Matrice Categories quando o componente monta
  useEffect(() => {
    fetchMatriceCategories();
  }, []);

  // ✅ Função para buscar os Research Areas Field da API
  const fetchResearchAreasFields = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/research-areas-fields');
      if (!response.ok) {
        throw new Error('Erro ao buscar Research Areas Field');
      }
      const data = await response.json();
      setResearchAreasFields(data); // Guardar os dados no estado
    } catch (error) {
      console.error('Erro ao buscar Research Areas Field:', error);
    }
  };

  // ✅ Buscar Research Areas Field quando o componente monta
  useEffect(() => {
    fetchResearchAreasFields();
  }, []);

  // Função para criar Equipamento
  const handleCreateEquipment = async () => {
    const newEquipment = {
      entity_id: entityId === '' ? null : entityId,
      sub_entity_id: subEntityId === '' ? null : subEntityId,
      category_id: categoryId === '' ? null : categoryId,
      matrice_id: matriceId === '' ? null : matriceId,
      process_type: processType === '' ? null : processType,
      equipment_name: equipmentName,
      applications: applications,
      observations: observations,
      scales: scales,
      main_specs: mainSpecs
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/equipments', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newEquipment)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar o equipamento');
      }

      alert('Equipamento criado com sucesso!');
    } catch (error) {
      alert('Erro ao criar equipamento');
    }
  };

  // Função para criar Patente
  const handleCreatePatent = async () => {
    const newPatent = {
      entity_id: patentEntityId === '' ? null : patentEntityId,
      publication_number: publicationNumber,
      publication_date: publicationDate,
      title: title,
      inventor: inventor
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/patents', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newPatent)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a patente');
      }

      alert('Patente criada com sucesso!');
    } catch (error) {
      alert('Erro ao criar patente');
    }
  };

  // Função para criar Project
  const handleCreateProject = async () => {
    const newProject = {
      entity_id: projectEntityId === '' ? null : projectEntityId,
      project_name: projectName,
      link: link,
      on_going: onGoing,
      project_acronimo: projectAcronym
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/projects', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newProject)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar o projeto');
      }

      alert('Projeto criado com sucesso!');
    } catch (error) {
      alert('Erro ao criar projeto');
    }
  };

  // Função para criar Skill
  const handleCreateSkill = async () => {
    const newSkill = {
      entity_id: skillEntityId === '' ? null : skillEntityId,
      research_areas_field_id: researchAreasFieldId === '' ? null : researchAreasFieldId,
      main_keywords: mainKeywords,
      research_topics: researchTopics,
      specific_keywords: specificKeywords
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/skills', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newSkill)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a skill');
      }

      alert('Skill criada com sucesso!');
    } catch (error) {
      alert('Erro ao criar skill');
    }
  };
  // Função para criar Research Area Field (R&I)
  const handleCreateResearchAreaField = async () => {
    const newResearchArea = {
      description: researchAreaDescription
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/research-areas-fields', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newResearchArea)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a área de pesquisa');
      }

      alert('Área de pesquisa criada com sucesso!');
      setOpenResearchAreaModal(false);
    } catch (error) {
      alert('Erro ao criar área de pesquisa');
    }
  };

  // Função para criar Matrice Category
  const handleCreateMatriceCategory = async () => {
    const newMatriceCategory = {
      matrice_id: matriceCategoryMatriceId === '' ? null : matriceCategoryMatriceId,
      description: matriceCategoryDescription
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrice-categories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newMatriceCategory)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a categoria de matriz');
      }

      alert('Categoria de Matriz criada com sucesso!');
    } catch (error) {
      alert('Erro ao criar categoria de matriz');
    }
  };

  // Função para criar Matrice Subcategory
  const handleCreateMatriceSubcategory = async () => {
    const newMatriceSubcategory = {
      matrice_category_id: matriceSubcategoryCategoryId === '' ? null : matriceSubcategoryCategoryId,
      description: matriceSubcategoryDescription
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/matrice-subcategories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newMatriceSubcategory)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a subcategoria de matriz');
      }

      alert('Subcategoria de Matriz criada com sucesso!');
    } catch (error) {
      alert('Erro ao criar subcategoria de matriz');
    }
  };
  // Função para criar Investigation Group
  const handleCreateInvestigationGroup = async () => {
    const newGroup = {
      entity_id: entityIdIG === '' ? null : entityIdIG,
      sub_entity_id: createdSubEntityId === '' ? null : createdSubEntityId,
      research_line: researchLine,
      researcher_name: researcherName,
      researcher_cv: researcherCv,
      email: email,
      biography: biography,
      description: descriptionIG
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/investigation-groups', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newGroup)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar o grupo de pesquisa');
      }

      alert('Grupo de Pesquisa criado com sucesso!');
    } catch (error) {
      alert('Erro ao criar o grupo de pesquisa');
    }
  };

  // Função para criar Sub-Entity
  const handleCreateSubEntity = async () => {
    const newSubEntity = {
      entity_id: entityIdSE === '' ? null : entityIdSE,
      type: type === '' ? null : type,
      name: nameSE,
      contact: contact,
      location: location1
    };

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/sub-entities', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newSubEntity)
      });

      if (!response.ok) {
        throw new Error('Erro ao criar a sub-entidade');
      }

      const data = await response.json(); // Supondo que a resposta contém a Sub-Entity criada

      // Armazenar o ID e o nome da Sub-Entity
      setCreatedSubEntityId(data.id);  // ID da Sub-Entity
      setSubEntityName(data.name);     // Nome da Sub-Entity

      alert('Sub-entidade criada com sucesso!');
    } catch (error) {
      alert('Erro ao criar a sub-entidade');
    }
  };

  useEffect(() => {
    // Ao sair da página ou resetar, limpar o ID
    return () => {
      setCreatedSubEntityId(''); // Limpar o ID quando o componente for desmontado ou a navegação ocorrer
    };
  }, []);


  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [openSubcategoryModal, setOpenSubcategoryModal] = useState(false);

  // Função para abrir/fechar o modal de categoria
  const handleOpenCategoryModal = () => setOpenCategoryModal(true);
  const handleCloseCategoryModal = () => setOpenCategoryModal(false);

  // Função para abrir/fechar o modal de subcategoria
  const handleOpenSubcategoryModal = () => setOpenSubcategoryModal(true);
  const handleCloseSubcategoryModal = () => setOpenSubcategoryModal(false);


  return (
    <Box>
      <Container maxWidth="md" sx={{ mt: 4 }}>
        {/* Tabs centralizadas */}
        <Tabs value={selectedTab} onChange={handleTabChange} centered>
          <Tab label="Faculty" />
          <Tab label="Food Matrices" />
          <Tab label="Equipments" />
          <Tab label="R&I" />
          <Tab label="Patents" />
          <Tab label="Projects" />
        </Tabs>

        <Paper sx={{ p: 3, mt: 2 }}>

          {selectedTab === 0 && (
            <>
              <Typography variant="h5">Create Entity</Typography>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={showInvestigationGroup} onChange={() => setShowInvestigationGroup(!showInvestigationGroup)} />}
                  label="Is Investigation Group?"
                />
                <FormControlLabel
                  control={<Checkbox checked={showSubEntity} onChange={() => setShowSubEntity(!showSubEntity)} />}
                  label="Is Sub-Entity?"
                />
              </FormGroup>

              {/* Investigation Group Card */}
              {showInvestigationGroup && (
                <Card sx={{ mt: 3 }}>
                  <CardContent>
                    <Typography variant="h6">Create Investigation Group</Typography>
                    <TextField
                      label="Entity ID"
                      fullWidth
                      margin="dense"
                      value={entityIdIG}
                      onChange={(e) => setEntityId(e.target.value)}
                      sx={{ display: 'none' }} />
                    <TextField
                      label="Sub Entity Name"
                      fullWidth
                      margin="dense"
                      value={subEntityName}
                      onChange={(e) => setSubEntityName(e.target.value)}
                      disabled={createdSubEntityId !== ''}
                    />

                    <TextField label="Research Line" fullWidth margin="dense" value={researchLine} onChange={(e) => setResearchLine(e.target.value)} />
                    <TextField label="Researcher Name" fullWidth margin="dense" value={researcherName} onChange={(e) => setResearcherName(e.target.value)} />
                    <TextField label="Researcher CV" fullWidth margin="dense" value={researcherCv} onChange={(e) => setResearcherCv(e.target.value)} />
                    <TextField label="Email" fullWidth margin="dense" value={email} onChange={(e) => setEmail(e.target.value)} />
                    <TextField label="Biography" fullWidth margin="dense" value={biography} onChange={(e) => setBiography(e.target.value)} />
                    <TextField label="Description" fullWidth margin="dense" value={descriptionIG} onChange={(e) => setDescriptionIG(e.target.value)} />
                    <Box sx={{ mt: 3 }}>
                      <Button variant="contained" color="primary" onClick={handleCreateInvestigationGroup}>Create Investigation Group</Button>
                    </Box>
                  </CardContent>
                </Card>
              )}

              {/* Sub-Entity Card */}
              {showSubEntity && (
                <Card sx={{ mt: 3 }}>
                  <CardContent>
                    <Typography variant="h6">Create Sub-Entity</Typography>
                    <TextField
                      label="Entity ID"
                      fullWidth
                      margin="dense"
                      value={entityIdSE}
                      onChange={(e) => setEntityId(e.target.value)}
                      sx={{ display: 'none' }} />
                    <TextField label="Type" fullWidth margin="dense" value={type} onChange={(e) => setType(e.target.value)} />
                    <TextField label="Name" fullWidth margin="dense" value={nameSE} onChange={(e) => setNameSE(e.target.value)} />
                    <TextField label="Contact" fullWidth margin="dense" value={contact} onChange={(e) => setContact(e.target.value)} />
                    <TextField label="Location" fullWidth margin="dense" value={location1} onChange={(e) => setLocation(e.target.value)} />
                    <Box sx={{ mt: 3 }}>
                      <Button variant="contained" color="primary" onClick={handleCreateSubEntity}>Create Sub-Entity</Button>
                    </Box>
                  </CardContent>
                </Card>
              )}
            </>
          )}

          {selectedTab === 1 && (
            <>
              <Typography variant="h5">Create Matrix</Typography>
              <TextField
                label="Entity ID"
                fullWidth
                margin="dense"
                value={matrixEntityId}
                onChange={(e) => setMatrixEntityId(e.target.value)}
                sx={{ display: 'none' }}
              />
              <TextField
                label="Observations"
                fullWidth
                margin="dense"
                value={matrixObservations}
                onChange={(e) => setMatrixObservations(e.target.value)}
              />
              <Box sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleCreateMatrix}
                >
                  Create Matrix
                </Button>
                <Button
                  variant="outlined"
                  sx={{ ml: 2 }}
                  onClick={handleOpenCategoryModal}
                >
                  Create Matrice Category
                </Button>
                <Button
                  variant="outlined"
                  sx={{ ml: 2 }}
                  onClick={handleOpenSubcategoryModal}
                >
                  Create Matrice Subcategory
                </Button>
              </Box>

              {/* Modal para criar Matrice Category */}
              <Dialog open={openCategoryModal} onClose={handleCloseCategoryModal}>
                <DialogTitle>Create Matrice Category</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth margin="dense">
                    <InputLabel>Matrice</InputLabel>
                    <Select
                      value={matriceCategoryMatriceId}
                      onChange={(e) => setMatriceCategoryMatriceId(e.target.value)}
                      label="Matrice"
                    >
                      {matrices.map((matrice) => (
                        <MenuItem key={matrice.id} value={matrice.id}>
                          {matrice.observations} {/* Exibe o nome da matriz */}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Description"
                    fullWidth
                    margin="dense"
                    value={matriceCategoryDescription}
                    onChange={(e) => setMatriceCategoryDescription(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseCategoryModal}>Cancel</Button>
                  <Button onClick={handleCreateMatriceCategory} color="primary">
                    Create
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Modal para criar Matrice Subcategory */}
              <Dialog open={openSubcategoryModal} onClose={handleCloseSubcategoryModal}>
                <DialogTitle>Create Matrice Subcategory</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth margin="dense">
                    <InputLabel>Matrice Category</InputLabel>
                    <Select
                      value={matriceSubcategoryCategoryId}
                      onChange={(e) => setMatriceSubcategoryCategoryId(e.target.value)}
                      label="Matrice Category"
                    >
                      {matriceCategories.map((category) => (
                        <MenuItem key={category.id} value={category.id}>
                          {category.description} {/* Exibe a descrição da categoria */}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Description"
                    fullWidth
                    margin="dense"
                    value={matriceSubcategoryDescription}
                    onChange={(e) => setMatriceSubcategoryDescription(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseSubcategoryModal}>Cancel</Button>
                  <Button onClick={handleCreateMatriceSubcategory} color="primary">
                    Create
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )}


          {/* Equipments */}
          {selectedTab === 2 && (
            <>
              <Typography variant="h5">Create Equipment</Typography>
              <TextField
                label="Entity ID"
                fullWidth
                margin="dense"
                value={entityId}
                onChange={(e) => setEntityId(e.target.value)}
                sx={{ display: 'none' }}
              />
              <TextField label="Sub Entity ID" fullWidth margin="dense" value={subEntityId} onChange={(e) => setSubEntityId(e.target.value)} sx={{ display: 'none' }} />
              <FormControl fullWidth margin="dense">
                <InputLabel>Category</InputLabel>
                <Select
                  value={categoryId}
                  onChange={(e) => setCategoryId(e.target.value)}
                  label="Category"
                >
                  {categories.map((category) => (
                    <MenuItem key={category.id} value={category.id}>
                      {category.category_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="dense">
                <InputLabel>Matrice</InputLabel>
                <Select
                  value={matriceId}
                  onChange={(e) => setMatriceId(e.target.value)}
                  label="Matrice"
                >
                  {matrices.map((matrice) => (
                    <MenuItem key={matrice.id} value={matrice.id}>
                      {matrice.observations}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="dense">
                <InputLabel>Process Type</InputLabel>
                <Select
                  value={processType}
                  onChange={(e) => setProcessType(e.target.value)}
                  label="Process Type"
                >
                  {processTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField label="Equipment Name" fullWidth margin="dense" value={equipmentName} onChange={(e) => setEquipmentName(e.target.value)} />
              <TextField label="Applications" fullWidth margin="dense" value={applications} onChange={(e) => setApplications(e.target.value)} />
              <TextField label="Observations" fullWidth margin="dense" value={observations} onChange={(e) => setObservations(e.target.value)} />
              <TextField label="Scales" fullWidth margin="dense" value={scales} onChange={(e) => setScales(e.target.value)} />
              <TextField label="Main Specs" fullWidth margin="dense" value={mainSpecs} onChange={(e) => setMainSpecs(e.target.value)} />
              <Box sx={{ mt: 3 }}>
                <Button variant="contained" color="primary" onClick={handleCreateEquipment}>
                  Create Equipment
                </Button>
              </Box>
            </>
          )}

          {/* R&I - Skills */}
          {selectedTab === 3 && (
            <>
              <Typography variant="h5">Create Skill</Typography>
              {/* Campos da Skill */}
              <TextField
                label="Entity ID"
                fullWidth
                margin="dense"
                value={skillEntityId}
                onChange={(e) => setEntityId(e.target.value)}
                sx={{ display: 'none' }}
              />
              <FormControl fullWidth margin="dense">
                <InputLabel>Research Area Field</InputLabel>
                <Select
                  value={researchAreasFieldId}
                  onChange={(e) => setResearchAreasFieldId(e.target.value)}
                  label="Research Area Field"
                >
                  {researchAreasFields.map((field) => (
                    <MenuItem key={field.id} value={field.id}>
                      {field.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField label="Main Keywords" fullWidth margin="dense" value={mainKeywords} onChange={(e) => setMainKeywords(e.target.value)} />
              <TextField label="Research Topics" fullWidth margin="dense" value={researchTopics} onChange={(e) => setResearchTopics(e.target.value)} />
              <TextField label="Specific Keywords" fullWidth margin="dense" value={specificKeywords} onChange={(e) => setSpecificKeywords(e.target.value)} />
              <Box sx={{ mt: 3 }}>
                <Button variant="contained" color="primary" onClick={handleCreateSkill}>
                  Create Skill
                </Button>
                {/* Botão para abrir o Modal de Research Area */}
                <Button variant="outlined" color="secondary" onClick={() => setOpenResearchAreaModal(true)} sx={{ ml: 2 }}>
                  Create Research Area
                </Button>
              </Box>
            </>
          )}

          {/* Modal para criação de Research Area Field */}
          <Dialog open={openResearchAreaModal} onClose={() => setOpenResearchAreaModal(false)}>
            <DialogTitle>Create Research Area</DialogTitle>
            <DialogContent>
              <TextField
                label="Description"
                fullWidth
                margin="dense"
                value={researchAreaDescription}
                onChange={(e) => setResearchAreaDescription(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenResearchAreaModal(false)} color="primary">
                Cancel
              </Button>
              <Button onClick={handleCreateResearchAreaField} color="primary">
                Create
              </Button>
            </DialogActions>
          </Dialog>



          {/* Patents */}
          {selectedTab === 4 && (
            <>
              <Typography variant="h5">Create Patent</Typography>
              <TextField
                label="Entity ID"
                fullWidth
                margin="dense"
                value={patentEntityId}
                onChange={(e) => setEntityId(e.target.value)}
                sx={{ display: 'none' }} />
              <TextField label="Publication Number" fullWidth margin="dense" value={publicationNumber} onChange={(e) => setPublicationNumber(e.target.value)} />
              <TextField label="Publication Date" type="date" fullWidth margin="dense" InputLabelProps={{ shrink: true }} value={publicationDate} onChange={(e) => setPublicationDate(e.target.value)} />
              <TextField label="Title" fullWidth margin="dense" value={title} onChange={(e) => setTitle(e.target.value)} />
              <TextField label="Inventor" fullWidth margin="dense" value={inventor} onChange={(e) => setInventor(e.target.value)} />
              <Box sx={{ mt: 3 }}>
                <Button variant="contained" color="primary" onClick={handleCreatePatent}>
                  Create Patent
                </Button>
              </Box>
            </>
          )}

          {/* Projects */}
          {selectedTab === 5 && (
            <>
              <Typography variant="h5">Create Project</Typography>
              <TextField
                label="Entity ID"
                fullWidth
                margin="dense"
                value={projectEntityId}
                onChange={(e) => setEntityId(e.target.value)}
                sx={{ display: 'none' }} />
              <TextField label="Project Name" fullWidth margin="dense" value={projectName} onChange={(e) => setProjectName(e.target.value)} />
              <TextField label="Link" fullWidth margin="dense" value={link} onChange={(e) => setLink(e.target.value)} />
              <TextField label="Project Acronym" fullWidth margin="dense" value={projectAcronym} onChange={(e) => setProjectAcronym(e.target.value)} />
              <FormControlLabel
                control={<Checkbox checked={onGoing} onChange={(e) => setOnGoing(e.target.checked)} />}
                label="On Going"
              />
              <Box sx={{ mt: 3 }}>
                <Button variant="contained" color="primary" onClick={handleCreateProject}>
                  Create Project
                </Button>
              </Box>
            </>
          )}
        </Paper>
      </Container>
            <Box>
              <Footer>
      
              </Footer>
            </Box>
    </Box>
  );
}
